import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tiktok.png'
import _imports_1 from '@/assets/vk.png'
import _imports_2 from '@/assets/tg.png'
import _imports_3 from '@/assets/like.png'
import _imports_4 from '@/assets/youtube.png'


const _withScopeId = n => (_pushScopeId("data-v-5920de73"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "soc-links-wrapper" }
const _hoisted_2 = { class: "soc-buttons" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "tiktok"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "vk"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "tg"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "like"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "like"
}, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

import { SOC_LIKE, SOC_NUUM, SOC_TG, SOC_TIKTOK, SOC_VK, SOC_YOUTUBE } from '@/helpers/globalVars'

export default /*#__PURE__*/_defineComponent({
  __name: 'SocLinks',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "soc-button tiktok",
        href: _unref(SOC_TIKTOK)
      }, _hoisted_5, 8, _hoisted_3),
      _createElementVNode("a", {
        class: "soc-button vk",
        href: _unref(SOC_VK)
      }, _hoisted_8, 8, _hoisted_6),
      _createElementVNode("a", {
        class: "soc-button tg",
        href: _unref(SOC_TG)
      }, _hoisted_11, 8, _hoisted_9),
      _createElementVNode("a", {
        class: "soc-button like",
        href: _unref(SOC_LIKE)
      }, _hoisted_14, 8, _hoisted_12),
      _createElementVNode("a", {
        class: "soc-button youtube",
        href: _unref(SOC_YOUTUBE)
      }, _hoisted_17, 8, _hoisted_15)
    ])
  ]))
}
}

})